<template>
  <div class>
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>Commandes clients</v-toolbar-title>
    </v-toolbar>
    <v-card elevation="0">
      <v-card-text>
        <v-data-table :headers="headers" :items="orders" :items-per-page="20" class="elevation-0">
          <template v-slot:item="{item}">
            <tr>
              <td>{{item.ref}}</td>
              <td>{{item.service.name}}</td>
              <td>{{item.orderDate}}</td>
              <td>
                <v-chip :color="getColor(item.status)" dark>{{item.status}}</v-chip>
              </td>
              <td>
                <v-dialog
                  v-model="deleteConfirm[item.id]"
                  max-width="450"
                  v-if="item.status=='draft'"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn icon fab small v-on="on">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>Confirmation</v-card-title>
                    <v-card-text>Etes-vous sûre d'effacer cette commande ?</v-card-text>
                    <v-card-actions>
                      <v-btn text @click="deleteConfirm[item.id]=false">Annuler</v-btn>
                      <v-spacer />
                      <v-btn class="primary" @click="onDelete(item)">Confirmer</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-btn icon @click="view(item)">
                  <v-icon>mdi-dots-horizontal</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data: function() {
    return {
      deleteConfirm: {},
      headers: [
        { text: "Référence", value: "ref" },
        { text: "Service", value: "service.id" },
        {
          text: "Date",
          align: "left",
          value: "orderDate"
        },
        { text: "Status", value: "status" },
        { text: "Actions", value: "action", sortable: false }
      ],
      serviceForm: false,
      valid: false,
      service: {
        type_id: 0,
        name: "",
        status: 0
      }
    };
  },
  computed: {
    ...mapState("order", {
      orders: state => state.list
    })
  },
  mounted: function() {
    this.getOrder();
  },
  methods: {
    ...mapActions("order", ["delete"]),
    getOrder() {
      this.$store.dispatch("order/list");
    },

    view(order) {
      this.$router.push("/orders/view/" + order.id);
    },

    getColor(status) {
      if (status == "paid") {
        return "red";
      }
      return "green";
    },
    formatAmount(amount) {
      return amount + " CHF";
    },
    onDelete(item) {
      this.delete(item).then(() => {
        console.log("DELETE");
      });
    }
  }
};
</script>

<style>
</style>